export default function () {
  return {
    isLoading: false,
    alertToast: null,
  }
}
